<script lang="ts">
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"

  interface Props {
    class?: string
    children?: Snippet
  }

  let { class: className = "", children }: Props = $props()
</script>

<!-- just a utility component for a shared wrapper. All Input types in this directory require the same classes applied to the container -->
<div class={cn("relative flex flex-row items-center gap-0.5", className)}>
  {@render children?.()}
</div>
